import Axios from 'axios';
import { TOKEN_KEY, baseURLAPI } from '@/config';
import Cookies from 'js-cookie';
import { MsgError } from '@/libs/util';

class httpRequest {
  constructor () {
    this.options = {
      method: '',
      url: ''
    };
    // 存储请求队列
    this.queue = {};
    this.blob = false;
  }
  // 销毁请求实例
  destroy (url) {
    delete this.queue[url];
    const queue = Object.keys(this.queue);
    return queue.length;
  }
  // 请求拦截
  interceptors (instance, url) {
    // 添加请求拦截器
    instance.interceptors.request.use(config => {
      /*      if (!config.url.includes('/users')) {
        config.headers['x-access-token'] = Cookies.get(TOKEN_KEY)
      } */
      // Spin.show()
      // 在发送请求之前做些什么
      return config;
    }, error => {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 添加响应拦截器
    instance.interceptors.response.use((res) => {
      if (res.request.responseType === 'blob') {
        return res;
      }
      let { data } = res;
      const is = this.destroy(url);
      if (!is) {
        setTimeout(() => {
          // Spin.hide()
        }, 500);
      }
      if (data.code !== 200) {
        // 后端服务在个别情况下回报201，待确认
        if (data.code === 401) {
          this.toLogin();
        } else {
          if (data.msg) MsgError(data.msg);
        }
        return false;
      }
      return data;
    }, (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          this.toLogin();
        } else {
          let msg = error.response.data.msg || '';
          MsgError(error.response.status + '  ' + msg);
        }
      } else {
        MsgError('服务内部错误:' + error);
      }
      // 对响应错误做点什么
      return Promise.reject(error);
    });
  }

  toLogin () {
    Cookies.remove(TOKEN_KEY);
    window.location.href = 'login';
    MsgError('未登录，或登录失效，请登录');
  }

  // 创建实例
  create () {
    let token = Cookies.get(TOKEN_KEY);
    let conf = {
      baseURL: baseURLAPI,
      // timeout: 2000,
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json; charset=utf-8',
        'X-URL-PATH': location.pathname
      }
    };
    return Axios.create(conf);
  }
  // 合并请求实例
  mergeReqest (instances = []) {
    //
  }
  // 请求实例
  request (options) {
    let instance = this.create();
    this.interceptors(instance, options.url);
    options = Object.assign({}, options);
    instance.blob = !!options.responseType;
    this.queue[options.url] = instance;
    return instance(options);
  }
}
export default httpRequest;
